(() => {
  function install(picker) {
    if(picker.dataset.cvDesktopReady)return;
    const fields=[...picker.querySelectorAll('fieldset.product-form__input--pill')];
    if(!fields.length)return;
    picker.dataset.cvDesktopReady='true';
    picker.classList.add('cv-mobile-picker');
    const wrapper=document.createElement('div');wrapper.className='cv-desktop-picker';
    fields.forEach((field,index)=>{
      const label=document.createElement('label');label.className='form__label';
      label.textContent=field.querySelector('legend')?.textContent||'';
      const box=document.createElement('div');box.className='product-form__input';
      const select=document.createElement('select');select.className='select__select';select.id='CvDesktop-'+picker.id+'-'+index;label.htmlFor=select.id;
      [...field.querySelectorAll('input[type="radio"]')].forEach(input=>{
        const option=document.createElement('option');option.value=input.value;option.textContent=input.value;option.selected=input.checked;option.disabled=input.disabled;select.append(option);
      });
      select.addEventListener('change',event=>{event.stopPropagation();const input=[...field.querySelectorAll('input[type="radio"]')].find(input=>input.value===select.value);input?.click();});
      const frame=document.createElement('div');frame.className='select';frame.append(select);box.append(label,frame);wrapper.append(box);
    });
    picker.after(wrapper);
  }
  function scan(){document.querySelectorAll('product-info[id^="MainProduct-"] variant-selects').forEach(install);document.querySelectorAll('.cv-desktop-picker').forEach(wrapper=>{if(!wrapper.previousElementSibling?.matches('variant-selects'))wrapper.remove();});}
  scan();new MutationObserver(scan).observe(document.body,{childList:true,subtree:true});
})();
